import {
  SYSTEM_GET_ALL_CHILD_POSTION_BEGIN,
  SYSTEM_GET_ALL_CHILD_POSTION_SUCCESS,
  SYSTEM_GET_ALL_CHILD_POSTION_FAILURE,
  SYSTEM_GET_ALL_CHILD_POSTION_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
/**
 * 获取所有子职位
 * 
 */
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllChildPostion(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEM_GET_ALL_CHILD_POSTION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      request({
        method: 'post',
        url: '/api/b/positionType/list',
        data: params,
      }).then(res => {
        dispatch({
          type: SYSTEM_GET_ALL_CHILD_POSTION_SUCCESS,
          data: res
        })
        resolve(res);
      }).catch(error => {
        dispatch({
          type: SYSTEM_GET_ALL_CHILD_POSTION_FAILURE,
          data: { error: error },
        });
        reject(error);
      })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllChildPostionError() {
  return {
    type: SYSTEM_GET_ALL_CHILD_POSTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_GET_ALL_CHILD_POSTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllChildPostionPending: true,
        getAllChildPostionError: null,
      };

    case SYSTEM_GET_ALL_CHILD_POSTION_SUCCESS:
      // The request is success
      let lst = []
      action.data.list.map(item => {
        if (item.pid > -1) {
          lst.push(Object.assign({} , item , {key:item.id}))
        }
      })

      return {
        ...state,
        getAllChildPostionPending: false,
        getAllChildPostionError: null,
        allChildPositionList: lst
      };

    case SYSTEM_GET_ALL_CHILD_POSTION_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllChildPostionPending: false,
        getAllChildPostionError: action.data.error,
      };

    case SYSTEM_GET_ALL_CHILD_POSTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllChildPostionError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/getAllChildPostion.js